<template>
  <div class="row">
    <div class="col-md-6">
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3 class="panel-title">Agregar Canchas</h3>
        </div>
        <div class="panel-body">
          <div class="form-group">
            <label>Club</label>
            <select v-model="club_id" class="form-control"
                    @change="fetchCourses">
              <option value=""></option>
              <option v-for="club in clubs" value="{{club.id}}">{{club.name}}</option>
            </select>
          </div>
          <table class="table table-condensed table-bordered table-striped">
            <tr>
              <th>Cancha</th>
              <th>Par</th>
              <th>Acción</th>
            </tr>
            <tr v-for="course in courses">
              <td>{{ course.name }}</td>
              <td>{{ course.par }}</td>
              <td>
                <button type="button" class="btn btn-default" @click="addCourse(course)">
                  <span class="glyphicon glyphicon-plus-sign" aria-hidden="true"></span>
                </button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3 class="panel-title">Canchas</h3>
        </div>
        <div class="panel-body">
          <table class="table table-bordered table-condensed">
            <tr>
              <th>Cancha</th>
              <th>Par</th>
              <th>Acción</th>
            </tr>
            <tr v-for="course in selected_courses">
              <td>{{ course.name }}</td>
              <td>{{ course.par }}</td>
              <td>
                <button type="button" class="btn btn-default" @click="removeCourse(course)">
                  <span class="glyphicon glyphicon-remove-sign" aria-hidden="true"></span>
                </button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import configure from '../../configure'
  import * as actions from '../../vuex/actions'
  import {
    getConfigChampionship,
    getConfigCourses
  } from '../../vuex/getters'
  export default {
    vuex: {
      getters: {
        championship: getConfigChampionship,
        selected_courses: getConfigCourses
      },
      actions: actions
    },
    data() {
      return {
        clubs: [],
        courses: [],
        club_id: null
      }
    },
    ready() {
      this.fetchClubs();
    },
    methods: {
      fetchClubs() {
        this.setLoading(true);
        this.$http.get(
          configure.api_url + 'clubs'
        ).then((response) => {
          this.clubs = response.data;
          this.setLoading(false);
        }, (error) => {
          this.setLoading(false);
          this.setError({show: true, message:'Error fetching clubs'})
        })
      },
      fetchCourses() {
        this.setLoading(true);
        this.$http.get(
          configure.api_url + 'courses?club_id=' + this.club_id
        ).then((response) => {
          this.courses = response.data;
          this.setLoading(false);
        }, (error) => {
          this.setLoading(false);
          this.setError({show: true, message:'Error fetching courses'})
        })
      },
      addCourse(course) {
        let selected_courses = this.selected_courses;
        this.setLoading(true);
        this.$http.post(
          configure.api_url + 'championships/' + this.championship.id + '/courses',
          course
        ).then((response) => {
          selected_courses.push(course);
          this.setConfigCourses(selected_courses);
          this.setLoading(false);
        }, (error) => {
          this.setLoading(false);
          this.setError({show: true, message:'Error fetching course'})
        })

      },
      removeCourse(course) {
        let selected_courses = this.selected_courses;
        this.setLoading(true);
        this.$http.put(
          configure.api_url + 'championships/' + this.championship.id + '/courses',
          course
        ).then((response) => {
          selected_courses.$remove(course);
          this.setConfigCourses(selected_courses);
          this.setLoading(false);
        }, (error) => {
          this.setLoading(false);
          this.setError({show: true, message:'Error updating course clubs'})
        });
      }
    }
  }
</script>

<style>

</style>



/** WEBPACK FOOTER **
 ** AddCourses.vue?52977940
 **/